import vmClient from 'app/services/vmClient';
import { Offset, OffsetMarshaller } from 'app/constants/schemas/Offset';
import { Sentence, ISentence } from 'app/constants/schemas/Sentence';
import { LocalSentence, ILocalSentence } from 'app/constants/schemas/LocalSentence';
import { WordSentence, IWordSentence } from 'app/constants/schemas/WordSentence';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

// Any value set to null means that it should never be set for this entity.
type VocabLocalSentenceAssociations = {
  localSentence: ILocalSentence;
  globalSentence: null;
  wordSentence: null;
} | {
  localSentence: null;
  globalSentence: ISentence;
  wordSentence: null;
};

interface IVocabWordSentenceLocal extends IEntity {
  attributes: {
    id: EntityStringId;
    localWordOffsets: Offset[];
    localTransliterationOffsets: Offset[];
  };
  associations: VocabLocalSentenceAssociations;
}

interface IVocabWordSentence extends IEntity {
  attributes: {
    id: EntityStringId;
    // Here, the local word offsets and transliteration offsets should _never_ be set because
    // this vocab word sentence is pointing at a WordSentence (which will internally handle its own offsets)
    localWordOffsets: null;
    localTransliterationOffsets: null;
  };
  associations: {
    localSentence: null;
    globalSentence: null;
    wordSentence: IWordSentence;
  };
}

export type IVocabSectionWordSentence = IVocabWordSentence | IVocabWordSentenceLocal;
export type VocabSectionWordSentence = Entity<IVocabSectionWordSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabSectionWordSentence: IEntityType<IVocabSectionWordSentence> = vmClient.defineClass({
  typeName: 'VocabSectionWordSentence',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    localWordOffsets: {
      collection: true,
      type: Offset,
      marshaller: OffsetMarshaller,
    },
    localTransliterationOffsets: {
      collection: true,
      type: Offset,
      marshaller: OffsetMarshaller,
    },
  },
  associations: {
    localSentence: LocalSentence,
    globalSentence: {
      type: Sentence,
      shared: true,
    },
    wordSentence: {
      type: WordSentence,
      shared: true,
    },
  },
});
